import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../../../hooks/useAxiosClient";
import { mapCollectionViewResponseToModel, mapPayoutViewResponseToModel, PayoutPmtStatus, PayoutViewDataResponse } from "../models/payoutViewModels";
import { TRootState } from "../../../../store";
import { setIsRefresh, setPayoutStatus, setPayoutView } from "./payoutViewSlice";
import { useEffect } from "react";


const usePayoutView = () => {


    const dispatch = useDispatch();
    const { handleGetCall } = useAxiosClient();

    const {
        adminId,
        payoutView,
        payoutType,
        isRefresh,
        payoutStatus
    } = useSelector((state: TRootState) => ({
        adminId: state.auth.adminId,
        payoutView: state.payoutView.payout,
        payoutType: state.payoutView.payoutType,
        isRefresh: state.payoutView.isRefresh,
        payoutStatus: state.payoutView.payoutStatus
    }));


    useEffect(() => {
        if (payoutType == "PAYOUT") {
            _getPayoutView();
        } else if (payoutType == "COLLECTION") {
            _getCollectionView();
        }

    }, []);

    const _getPayoutView = async () => {
        handleGetCall<PayoutViewDataResponse>(`payments/payouts/adminId/${adminId}/payoutId/${payoutView.payoutId}`)
            .then((res) => {
                if (res.data != null) {
                    dispatch(
                        setPayoutView({
                            payout: mapPayoutViewResponseToModel(res.data),
                        }),
                    );
                }
            });
    }

    const _getCollectionView = async () => {
        handleGetCall<PayoutViewDataResponse>(`payments/payouts/collections/adminId/${adminId}/utr/${payoutView.utr}`)
            .then((res) => {
                if (res.data != null) {
                    dispatch(
                        setPayoutView({
                            payout: mapCollectionViewResponseToModel(res.data),
                        }),
                    );
                }
            });
    }

    useEffect(() => {
        if (isRefresh) {
            getPmtStatus();
        }
    }, [isRefresh])

    const getPmtStatus = () => {
         if (!payoutView?.payoutId) return;
        dispatch(setIsRefresh(true));
        handleGetCall<PayoutPmtStatus[]>(
            `payments/payouts/status/adminId/${adminId}/payoutId/${payoutView.payoutId}`
        ).then(({ data }) => {
            if (data) {
                dispatch(setPayoutStatus(data));
            }
        }).catch((err) => {
            console.error(err);
        }).finally(() => {
            dispatch(setIsRefresh(false));
        });
    }

    const handleRefresh = () => {
        dispatch(setIsRefresh(true));
    }

    return {
        payoutView,
        payoutType,
        handleRefresh,
        isRefresh,
        payoutStatus
    }

}

export default usePayoutView;